<template>
    <div :class="$style['order']">
        <transition name="fade" mode="out-in">
            <PopupResult key="result"
                         v-if="isSuccess || isError"
                         :phone="phone"
                         :isSuccess="isSuccess"
                         :isError="isError"
                         :errorMessage="errorMessage"/>

            <div v-else :class="$style['order__content']">
                <div :class="['h2', $style['order__title']]">Заявка на ипотеку</div>

                <div>
                    <div :class="$style['order__bank']" v-if="bank">
                        <div :class="$style['order__bank-top']">
                            <div :class="$style['order__bank-logo']">
                                <img :src="bank.logo" alt="">
                            </div>

                            <div :class="$style['order__bank-name']"
                                 :style="{color: `#${program.color || bank.color}`}">
                                {{ program.bank || bank.bank }}
                            </div>
                        </div>

                        <div :class="$style['order__bank-caption']">{{ program.name }}</div>

                        <div :class="$style['order__bank-props']">
                            <div :class="$style['order__bank-prop']">
                                <div :class="$style['order__bank-props-ttl']">cтавка</div>
                                <div :class="$style['order__bank-props-val']">от {{ program.rate }}%</div>
                            </div>

                            <div :class="$style['order__bank-prop']">
                                <div :class="$style['order__bank-props-ttl']">1-й взнос</div>
                                <div :class="$style['order__bank-props-val']">от {{ program.firstPay }}%</div>
                            </div>

                            <div :class="$style['order__bank-prop']">
                                <div :class="$style['order__bank-props-ttl']">cрок</div>
                                <div :class="$style['order__bank-props-val']">до {{ program.term }} лет</div>
                            </div>

                            <div :class="$style['order__bank-prop']">
                                <div :class="$style['order__bank-props-ttl']">платёж</div>
                                <div :class="$style['order__bank-props-val']">{{ formatPrice(program.pay) }} руб.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <form :action="action"
                      :method="method"
                      :class="$style['order__form']"
                      :id="formId"
                      ref="mortgageOrderForm"
                      data-validate="true"
                      data-validate-check="key"
                      @submit.prevent="checkSmartCaptcha">

                    <div ref="captcha"></div>

                    <input type="hidden" name="message_bot" v-model="bot">

                    <div v-show="initialContent">
                        <div :class="$style['order__input-double']">
                            <div :class="$style['order__input']">
                                <Input v-model="name"
                                       name="first_name"
                                       placeholder="Как вас зовут?"
                                       :required="true"/>
                            </div>

                            <div :class="$style['order__input']">
                                <Input v-model="phone"
                                       name="phone"
                                       type="tel"
                                       placeholder="+ 7 (ХХХ) ХХХ-ХХ-ХХ"
                                       :required="true"/>
                                <div :class="$style['order__sms-info']">На&nbsp;данный номер будет отправлен смс&#8209;код</div>
                            </div>
                        </div>

                        <div :class="$style['order__person']">
                            <Checkbox v-model="person"
                                      name="person"
                                      :required="true">
                                Я согласен с <a target="_blank" :href="personLink">условиями обработки данных</a>
                            </Checkbox>
                        </div>
                    </div>

                    <div v-if="stepContent">
                        <div :class="$style['order__caption']">
                            На ваш номер {{ phone }} отправлен смс-код для подтверждения. Введите его в поле ниже:
                        </div>

                        <div :class="$style['order__input-double']">
                            <div :class="[$style['order__input'], $style['order__sms-input']]">
                                <Input v-model="code"
                                       name="code"
                                       placeholder="Смс-код"
                                       :required="isCodeRequired"/>
                            </div>
                        </div>

                        <div v-if="stepError" :class="[$style['order__error'], $style[`order__error_type_${errorType}`]]">
                            {{ errorMessage }}
                        </div>

                        <div v-if="showCounter" :class="$style['order__counter']">
                            Не получили код? Повторно код можно получить через
                            <span> {{ counter }} </span>секунд
                        </div>

                        <div v-if="showRequest" :class="$style['order__repeat']"
                             :repeatRequest="true" @click.prevent="checkSmartCaptcha(true)">
                            Получить код повторно
                        </div>
                    </div>

                    <div :class="[$style['order__submit']]">
                        <Button :disabled="stepError" type="submit" modify="auto">Подать заявку</Button>
                        <div v-show="stepContent" @click.prevent="stepBack" :class="$style['order__back']">
                            Изменить номер телефона
                        </div>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios';
    import Button from '../Button/Button';
    import Input from '../forms/Input/Input';
    import Checkbox from '../forms/Checkbox/Checkbox';
    import PopupResult from '../PopupResult/PopupResult';
    import {Utils} from '../../../../src/common/scripts/utils';

    const SMARTCAPTCHA_KEY = 'ysc1_W5qdp0unrahg9Qrv4EF4pEgLZFMYz9QYeswNljVt93211c7c';

    export default {
        components: {
            Button,
            Checkbox,
            Input,
            PopupResult
        },

        props: ['bank', 'program', 'personLink', 'sendData', 'isSuccess', 'isError'],

        data: () => ({
            action: '/ajax/api.php',
            method: 'post',
            formId: 'mortgage-order-form',
            name: '',
            phone: '',
            code: '',
            person: true,
            bot: '',
            request: {
                isSend: false
            },
            stepError: false,
            errorMessage: '',
            isStepForm: true,
            initialContent: true,
            stepContent: false,
            isCodeRequired: false,
            counterValue: 59,
            counter: '',
            showCounter: true,
            showRequest: false,
            widgetId: null,
            smartTokenField: null,
            eventTarget: null,
        }),

        methods: {
            send() {
                this.isRepeatRequest = this.eventTarget.hasAttribute('repeatRequest');
                const sendData = this.collectData();

                axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                axios[this.method](this.action, sendData)
                    .then((response) => {
                        const status = response.data.request.status;
                        const requestStatus = response.data.data.requestStatus;
                        this.formDataResponse = response.data.data;
                        this.isRequestProceeding =
                            Object.prototype.hasOwnProperty.call(response.data.data, 'requestStatus');
                        this.request.isSend = true;

                        if (status) {
                            !requestStatus
                                ? this.isRepeatRequest ? this.repeatCountdown() : this.stepHandler()
                            : this.sendIsSuccess();
                        } else {
                            this.errorMessage = this.formDataResponse.errorMessage;
                            this.errorType = this.formDataResponse.errorType;
                            throw new Error('Ошибка на сервере');
                        }
                    })
                    .catch((error) => {
                        this.isRequestProceeding ? this.stepSendIsError() : this.sendIsError();
                        console.error(error); // eslint-disable-line
                    });
            },

            collectData() {
                this._insertAntiSpam();
                const sendData = new FormData();

                if (this.bank) {
                    sendData.append('idBank', `${this.bank.idBank}`);
                }

                if (this.program) {
                    sendData.append('id', `${this.program.id}`);
                }

                sendData.append('stepForm', this.isStepForm);
                sendData.append('fio', this.name);
                sendData.append('phone', this.phone);

                this.isRepeatRequest ? sendData.set('code', '') : sendData.append('code', this.code);

                for (const data of this.sendData) {
                    sendData.append(data[0], data[1]);
                }

                sendData.append('message_bot', this.bot);
                sendData.append('url', window.location.href);
                sendData.append('event', 'mortgage');
                sendData.append('smart-token', this.smartTokenField ? this.smartTokenField.value : null);

                return sendData;
            },

            _insertAntiSpam() {
                const minRandom = 1;
                const maxRandom = 10;

                this.bot = `nospam ${Utils.random(minRandom, maxRandom)}`;
            },

            formatPrice(value) {
                let val = (value/1).toFixed(0).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },

            stepHandler() {
                this.initialContent = false;
                this.stepContent = true;
                this.isCodeRequired = true;

                this.setCountdown();
            },

            stepBack() {
                this.stepContent = false;
                this.isCodeRequired = false;
                this.showRequest = false;
                this.showCounter = true;
                this.stepError = false;
                this.initialContent = true;

                this.stopCountdown();
            },

            setCountdown() {
                this.counter = this.counterValue;

                this.countdown = setInterval(() => {
                    --this.counter;

                    if (this.counter === 0) {
                        this.stopCountdown();
                        this.showRepeatRequest();
                    }
                }, 1000);
            },

            stopCountdown() {
                clearInterval(this.countdown);
            },

            showRepeatRequest() {
                this.showRequest = true;
                this.showCounter = false;
            },

            repeatCountdown() {
                this.showRequest = false;
                this.stepError = false;
                this.showCounter = true;
                this.setCountdown();
            },

            sendIsSuccess() {
                this.resetSmartCaptcha();
                this.$emit('formSuccess');
            },

            sendIsError() {
                this.$emit('formError');
            },

            stepSendIsError() {
                this.stopCountdown();
                const isCodeError = this.formDataResponse.errorType !== 'smsLimitExpired';
                isCodeError ? this.showRequest = true : this.showRequest = false;
                this.showCounter = false;
                this.stepError = true;
            },

            /**
             * Метод запускает Яндекс-капчу перед отправкой формы
             */
            checkSmartCaptcha(isRepeat = false) {
                if (!window.smartCaptcha) {
                    return;
                }

                if (isRepeat) {
                    this.resetSmartCaptcha();
                }

                this.eventTarget = event.target

                if (this.stepContent && !isRepeat) {
                    this.send()
                } else {
                    window.smartCaptcha.execute(this.widgetId);
                }
            },

            resetSmartCaptcha() {
                window.smartCaptcha.reset(this.widgetId);
            },

            captchaCallback(token) {
                if (token) {
                    this.token = token;

                    if (this.smartTokenField) {
                        this.smartTokenField.value = token;
                    }

                    this.send();
                } else {
                    console.error('no token');

                    if (this.smartTokenField) {
                        this.smartTokenField.value = '';
                    }
                }
            }
        },

        mounted() {
            if (!window.smartCaptcha) {
                return;
            }

            const captcha = this.$refs.captcha

            if (captcha) {
                this.widgetId = window.smartCaptcha.render(captcha, {
                    sitekey   : SMARTCAPTCHA_KEY,
                    callback  : (token) => this.captchaCallback(token),
                    test      : false, // для отладки - задание может приходить каждый раз
                    invisible : true, // Делает капчу невидимой
                    hideShield: true // Делает предупреждающую плашку невидимой
                });

                this.smartTokenField = this.$refs.mortgageOrderForm.querySelector('input[name="smart-token"]') || null;
            }
        }
    }
</script>

<style lang="scss" module>
    @import "./Order";
</style>
